import { useState } from 'react'
import { authApi } from '@/api/auth'
import { useAuth } from '@/stores/auth'

/**
 * US-E2-001 — Welcome screen.
 * AC #1: Given первый вход после регистрации, When открывается welcome-экран,
 * Then показано УТП + кнопка «Начать».
 *
 * AC #2 (Stepper «Шаг N из M») — отложен до US-E2-002 (анкета).
 */
export function Welcome() {
  const { user, setUser } = useAuth()
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onStart = async () => {
    setError(null)
    setSubmitting(true)
    try {
      const updated = await authApi.welcomeComplete()
      setUser(updated)
      // US-E2-002 — после welcome ведём в анкету.
      window.location.assign('/onboarding/survey')
    } catch (e) {
      setError(
        e instanceof Error ? e.message : 'Не удалось сохранить. Попробуйте ещё раз.'
      )
      setSubmitting(false)
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-surface-canvas px-4 py-12">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-action-primary-bg/10 text-action-primary-bg rounded-full text-xs font-bold uppercase tracking-wider">
          Добро пожаловать{user?.display_name ? `, ${user.display_name}` : ''}
        </div>

        <h1 className="font-display text-3xl md:text-5xl font-bold text-text-primary tracking-[-0.02em]">
          Стань акционером — найми AI&nbsp;CEO
        </h1>

        <p className="text-base md:text-lg text-text-secondary leading-relaxed max-w-xl mx-auto">
          AgentCEO — гибридная компания из AI-агентов и живых специалистов
          под управлением AI Генерального Директора. Ты остаёшься
          акционером — мы&nbsp;ведём проект от&nbsp;идеи до&nbsp;результата.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-xl mx-auto pt-4">
          <div className="text-left p-4 rounded-lg border border-border bg-surface-subtle">
            <div className="text-2xl mb-2" aria-hidden>1</div>
            <p className="text-sm text-text-primary font-medium">Расскажи о&nbsp;бизнесе</p>
          </div>
          <div className="text-left p-4 rounded-lg border border-border bg-surface-subtle">
            <div className="text-2xl mb-2" aria-hidden>2</div>
            <p className="text-sm text-text-primary font-medium">Выбери CEO</p>
          </div>
          <div className="text-left p-4 rounded-lg border border-border bg-surface-subtle">
            <div className="text-2xl mb-2" aria-hidden>3</div>
            <p className="text-sm text-text-primary font-medium">Получи первый результат</p>
          </div>
        </div>

        {error && (
          <div role="alert" className="text-sm text-status-danger-text">
            {error}
          </div>
        )}

        <div className="pt-4">
          <button
            type="button"
            onClick={onStart}
            disabled={submitting}
            className="px-8 py-3 rounded-lg bg-action-primary-bg text-text-on-brand font-semibold text-base hover:bg-action-primary-bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus/40 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {submitting ? 'Загружаем…' : 'Начать'}
          </button>
        </div>

        <p className="text-xs text-text-secondary pt-2">
          14&nbsp;дней бесплатно · без&nbsp;карты · отмена в&nbsp;любой момент
        </p>
      </div>
    </main>
  )
}
